
type Props = {
  children: React.ReactNode
}

const HeroB2B = ({
  children,
}: Props) => {
  return (
    <div className="hero-section__b2b">
      <div className="hero-section__wrap" />
      {children}
    </div>
  )
}

export default HeroB2B
